import React from 'react';
import {connect} from "react-redux";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CustomPaper from '../../../shared/utils/CustomPaper';
import AuthService from './../../../../services/AuthService';
import moment from './../../../shared/utils/moment_fr';
import FlatButton from 'material-ui/RaisedButton';
import CustomDatePicker from './../../../shared/utils/CustomDatePicker';
import {TextValidator, ValidatorForm} from 'react-material-ui-form-validator';
import Dialog from 'material-ui/Dialog';
import Toggle from 'material-ui/Toggle';
import {renderEmail} from 'react-html-email-browser';
import emailFunc from '../../../shared/utils/ConvocationEmailComponent';
import {getOpenedEntretiens} from './../../../../actions/salarie/actions_salarie_1';
import Alert from "../../../shared/utils/Alert";


class ConvoquerUnSalarie extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            salarie: {id: 0},
            rdv: {
                day: new Date(),
                hour: '09',
                minute: '30'
            },
            openDialog: false,
            emailActivation: true,
            emailContent: ''
        };
        this.Auth = new AuthService();
        this.getOpenedEntretiens = this.getOpenedEntretiens.bind(this);
        this.handleDeleteEntretien = this.handleDeleteEntretien.bind(this);
        this.setDate = this.setDate.bind(this);
        this.handleSubmit1 = this.handleSubmit1.bind(this);
        this.handleSubmit2 = this.handleSubmit2.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let toReturn = nextProps.salaries.filter(x => x.id === nextProps.match.params.id_salarie)[0];
        toReturn = toReturn || nextProps.salaries[0];
        for (let key in toReturn) {
            if (toReturn.hasOwnProperty(key) && key.startsWith('date_')) {
                toReturn[key] = new Date(toReturn[key]);
            }
        }

        return {...prevState, salarie: toReturn};
    }

    getOpenedEntretiens() {
        let id_salarie = this.props.match.params.id_salarie;
        this.props.dispatch(getOpenedEntretiens(id_salarie));
    }

    componentDidMount(nextProps) {
        this.getOpenedEntretiens();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params.id_salarie !== this.props.match.params.id_salarie)
            this.getOpenedEntretiens();
    }

    handleDeleteEntretien(id) {
        if (window.confirm('Voulez vous vraiment supprimer l\'entretien sélectionné ? \nToutes les données liées à l\'entretien seront perdues.')) {
            this.Auth.fetch('/societe/entretien/' + id, {method: 'delete'})
                .then(resp => {
                    window.alert('Entretien supprimé avec succès.');
                    this.getOpenedEntretiens(this.state.salarie.id)
                })
        }
    }

    setDate(value, position) {
        switch (position) {
            case 'day':
                this.setState({rdv: {...this.state.rdv, day: value}});
                break;
            case 'hours' :
                value = parseInt(value, 10);
                value = value < 10 ? '0' + value : '' + value;
                this.setState({rdv: {...this.state.rdv, hour: value}});
                break;
            case 'minutes' :
                value = parseInt(value, 10);
                value = value < 10 ? '0' + value : '' + value;
                this.setState({rdv: {...this.state.rdv, minute: value}});
                break;
            default:
                break;
        }

    }

    handleSubmit1() {
        const datetime = moment(this.state.rdv.day).format('ll') + ' - ' + this.state.rdv.hour + ':' + this.state.rdv.minute;
        const msg = emailFunc(this.props.nomEntreprise, datetime);
        this.setState({emailContent: msg, openDialog: true});
    }

    handleSubmit2() {
        if (this.state.emailActivation) {
            const emailBody = renderEmail(this.state.emailContent);
            console.log(emailBody);
            this.Auth.fetch('/services/email',
                {
                    method: 'post',
                    data: {
                        msg: emailBody,
                        subject: 'Convocation pour entretien professionnel.',
                        to: this.state.salarie.email
                    }
                }).then(resp => window.alert('Email envoyé avec succès.'));
        }
        this.Auth.fetch('/societe/entretien',
            {
                method: 'post',
                data: {
                    date_heure: moment(this.state.rdv.day).hours(this.state.rdv.hour).minutes(this.state.rdv.minute).unix(),
                    id_salarie: this.state.salarie.id
                }
            }).then(resp => {
            this.getOpenedEntretiens();
            alert('Entretien planifié avec succès.');
        });
        this.setState({openDialog: false});
    }

    render() {
        const salaries = [];
        const oe = this.props.opened_entretien;
        this.props.salaries.map(x => salaries.push(<MenuItem key={x.id} value={x.id}
                                                             primaryText={x.nom + " " + x.prenom}/>));
        if (salaries.length > 0) {
            return (
                <div className={'container'}>
                    <CustomPaper title='Convoquer un salarié'>
                        <div className={'row justify-content-center'}>
                            <SelectField
                                value={this.state.salarie.id}
                                floatingLabelText='Salarié à convoquer'
                                onChange={(x, y, z) => this.props.history.push('/entreprise/convoquer_un_salarie/' + z)}
                                maxHeight={400}>
                                {salaries}
                            </SelectField>
                        </div>
                        {oe.length > 0 ?
                            <div className={'text-center'} style={{
                                paddingTop: 80,
                                paddingRight: 10,
                                paddingLeft: 10,
                                color: 'orange',
                                minHeight: 350
                            }}>
                                <strong>Un entretien est déjà programmé
                                    pour {oe[0].nom + ' ' + oe[0].prenom + ' pour la date : ' + moment(oe[0].date_heure).format('lll')}</strong><br/><br/>
                                <FlatButton label="Reprendre"
                                            onClick={() => this.props.history.push('/entreprise/passer_entretien/' + oe[0].id + '/1')}
                                            primary={true} style={{marginRight: 20}}/>
                                <FlatButton label="Supprimer" onClick={() => this.handleDeleteEntretien(oe[0].id)}/>
                            </div>
                            : <div className={'row justify-content-md-center'} style={{minHeight: 350}}>
                                <div className={'col col-sm-10'}>
                                    <ValidatorForm
                                        onSubmit={(x) => this.handleSubmit1()}
                                    >
                                        <CustomDatePicker
                                            floatingLabelText={"Date de l'entretien"}
                                            stringValue={moment(this.state.rdv.day).format('YYYY-MM-DD')}
                                            onChange={(x, y) => this.setDate(y, 'day')}
                                        />
                                        <div className={'row'}>
                                            <div className={'col'}>
                                                <TextValidator
                                                    value={this.state.rdv.hour}
                                                    onChange={(x, y) => this.setDate(y, 'hours')}
                                                    fullWidth={true}
                                                    name='hours'
                                                    type="number"
                                                    validators={['required', 'isNumber', 'minNumber:0', 'maxNumber:23']}
                                                    errorMessages={[
                                                        'Ce champs est obligatoire',
                                                        'Ce champs est doit représenter une heure (hh).',
                                                        'Valeur minimale : 0',
                                                        'Valeur maximale : 23',
                                                    ]}
                                                    floatingLabelText="Heure"
                                                />
                                            </div>
                                            <div className={'col'}>
                                                <TextValidator
                                                    value={this.state.rdv.minute}
                                                    onChange={(x, y) => this.setDate(y, 'minutes')}
                                                    fullWidth={true}
                                                    type="number"
                                                    name='minutes'
                                                    validators={['required', 'isNumber', 'minNumber:0', 'maxNumber:59']}
                                                    errorMessages={[
                                                        'Ce champs est obligatoire',
                                                        'Ce champs est doit représenter des minutes (mm).',
                                                        'Valeur minimale : 0',
                                                        'Valeur maximale : 59',
                                                    ]}
                                                    floatingLabelText="Minutes"
                                                />
                                            </div>

                                        </div>
                                        <br/><br/>
                                        <Dialog
                                            title="Convocation pour entretien"
                                            actions={[
                                                <FlatButton
                                                    label="Annuler"
                                                    style={{marginRight: 20}}
                                                    primary={false}
                                                    onClick={() => this.setState({openDialog: false})}
                                                />,
                                                <FlatButton
                                                    label="Valider"
                                                    primary={true}
                                                    onClick={this.handleSubmit2}
                                                />,
                                            ]}
                                            autoScrollBodyContent={true}
                                            modal={true}
                                            open={this.state.openDialog}
                                        >
                                            <Toggle
                                                label="Prévenir par email"
                                                labelPosition="right"
                                                toggled={this.state.emailActivation}
                                                onToggle={(x, y) => this.setState({emailActivation: y})}
                                            />
                                            {
                                                this.state.emailActivation
                                                    ?
                                                    <div>
                                                        <TextValidator
                                                            value={this.state.salarie.email}
                                                            onChange={(x, y) => this.setState({
                                                                salarie: {
                                                                    ...this.state.salarie,
                                                                    email: y
                                                                }
                                                            })}
                                                            fullWidth={true}
                                                            type="email"
                                                            name='email'
                                                            validators={['required', 'isEmail']}
                                                            errorMessages={[
                                                                'Ce champs est obligatoire',
                                                                'Ce champs doit être une adresse email.'
                                                            ]}
                                                            floatingLabelText="Email"
                                                        /><br/><br/>
                                                        {this.state.emailContent}
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </Dialog>
                                        <FlatButton type='submit' label="Convoquer" primary={true}/>
                                    </ValidatorForm>
                                </div>
                            </div>
                        }
                    </CustomPaper>
                </div>);
        } else {
            return <Alert text="Veuillez d'abord ajouter des salarié."/>;
        }
    }
}

function mapStateToProps(store) {
    return {
        salaries: store.entreprise.entreprise_infos.salaries,
        nomEntreprise: store.entreprise.entreprise_infos.nom,
        opened_entretien: store.salarie.entretiens.opened
    }
}

export default connect(mapStateToProps)(ConvoquerUnSalarie);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/salaries/ConvoquerUnSalarie.js